module.exports = __webpack_public_path__ + "static/img/logo06.08b83097.png";